import { render, staticRenderFns } from "./PrivacyPolicyZH.vue?vue&type=template&id=107265c7&scoped=true"
import script from "./PrivacyPolicyZH.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyZH.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyZH.vue?vue&type=style&index=0&id=107265c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107265c7",
  null
  
)

export default component.exports